export interface GetTemplateResourceRequest {
	SiteId?: number;
	LanguageName?: string;
	ProductType?: string;
	VisualType?: string;
	ProductId?: number;
}

export interface TemplateResourceContextProps {
	productId?: number|undefined;
	setProductId: (value?: number) => void;
	productType?: string;
	setProductType: (value: string) => void;
	templateResource: TemplateResource;
	isSuccess: boolean;
	isFetching: boolean;
}

export interface TemplateResource {
	ProductResources: Array<ProductResource>;
	SubProductResources: Array<SubProductResource>;
	VisualResources: Array<VisualResource>;
	TemplateName: string;
}

export interface ProductResource {
	Id: number;
	Name: string;
	Message?: string;
	ClassName?: string;
	TheURL?: string;
	OpenType?: number;
	Sort: number;
	LanguageName: string;
	SiteName: string;
	TypeName: string;
	SiteConfigKey?: string;
}

export interface SubProductResource {
	Id: number;
	Name: string;
	IsNew?: boolean;
	Message?: string;
	ClassName?: string;
	TheURL?: string;
	SiteConfigKey?: string;
	Parameters?: string;
	BetType?: number;
	PageSize?: string;
	Sort: number;
	ProductId: number;
	SportId?: string;
}

export interface VisualResource {
	Id: number;
	Src?: string;
	Alt?: string;
	Sort?: number;
	TypeName: string;
	LanguageName: string;
	SiteName: string;
}

export enum OpenTypeEnum {
	Inner = 0,
	Popup = 1,
}